import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import LiveSessionIcon from "../../../assets/images/LiveSession/liveIcon.png";
import "../styles/LivSessionBotStyles.css";

const ActiveLiveSessionLogo: React.FC = () => {
  const liveSessionUrl = useSelector(
    (state: RootState) => state.profile.livesessionurl
  );

  // Function to handle click and redirect
  const handleIconClick = () => {
    if (liveSessionUrl) {
      // Open in new tab
      window.open(liveSessionUrl, "_blank", "noopener,noreferrer");
    }
  };

  // Only render if session URL exists
  if (!liveSessionUrl) {
    return null;
  }

  return (
    <div onClick={handleIconClick} style={{ cursor: "pointer" }}>
      <div className="livesessionurl-icon">
        <img src={LiveSessionIcon} alt="" className="livesessionurl-image" />
      </div>
    </div>
  );
};

export default ActiveLiveSessionLogo;
